import {TRANSLATION, Yup} from '@/imports-files/components/add-to-job-modal';

const phoneRegex = /^\+?[\d\s]+$/;

export function offerInitialValues(offerHash){

	let salary = offerHash.offer ? offerHash.offer.salary : ''
	let benefits = offerHash.offer ? offerHash.offer.benefits : ''
	let salary_period = offerHash.offer ? offerHash.offer.salary_period : ''
	let start_date = offerHash.offer ? offerHash.offer.start_date : ''
  let employer = offerHash.offer ? offerHash.offer.employer || '' : ''
  let personal_id_number = offerHash.offer ? offerHash.offer.personal_id_number || '' : ''

  const	data = {
				offer: {
					job_application_id: offerHash.job_application_id,
		          	job_application_attributes: {
		            contact_no: offerHash.contact_no,
		            id: offerHash.job_application_id,
		            client_candidate_attributes: {
		              id: offerHash.client_candidate_id,
		              name: offerHash.name,
		              email: offerHash.email
		            }
		          },
		          title: offerHash.title,
		          job_title: offerHash.job_title,
				      location: offerHash.location,
		          employment_type: offerHash.employment_type,
		          contract_type: offerHash.contract_type,
		          remote: offerHash.remote,
		          salary: salary,
		          salary_period: salary_period,
		          currency_id: offerHash.currency_id,
		          benefits: benefits,
		          start_date: start_date,
              email: offerHash.email,
              contact_no: offerHash.contact_no,
              name: offerHash.name,
              employer: employer,
              personal_id_number: personal_id_number,
              location_attributes: {
                full_address: offerHash.full_address
              },
							offer_approvals_attributes: [
								{
									minimum_approval_required: offerHash.offer?.minimum_approval_required || '',
									approver_emails: offerHash.offer?.approvers?.map((x) => x.email) || [],
									approver_initials: offerHash.offer?.approvers || [],
									is_default: true,
									client_id: offerHash.client_id,
								}
							]
	      	},
				}
	return data;      	
}

export function offerValidationSchema(validation, locationValidation, syncFormValidation){
  let showValidation = validation
  let locationValidationCheck = locationValidation
  let a = {
                                                  offer: Yup.object().shape({

                                                    salary: Yup.string().required(TRANSLATION('errors:required')).nullable(true),
                                                    salary_period: Yup.string().required(TRANSLATION('errors:required')),
                                                    currency_id: Yup.string().required(TRANSLATION('errors:required')),
                                                    // benefits: Yup.string().required(TRANSLATION('errors:required')),
                                                    start_date: Yup.string().required(TRANSLATION('errors:required')).nullable(true),
                                                    job_title: Yup.string().required(TRANSLATION('errors:required')),
                                                    employment_type: Yup.string().required(TRANSLATION('errors:required')),
                                                    contract_type: Yup.string().required(TRANSLATION('errors:required')),
                                                    name: Yup.string().required(TRANSLATION('errors:required')),
                                                    business_unit: Yup.string().nullable(),
                                                    team: Yup.string().nullable(),
                                                    syncValidation: Yup.boolean(),
                                                    employer: Yup.string().when("syncValidation",{
                                                                         is: (syncValidation) => {return syncFormValidation},
                                                                          then: Yup.string().required(TRANSLATION('errors:required')).nullable(true),
                                                                          otherwise: Yup.string().nullable()
                                                          }),
                                                    personal_id_number: Yup.string().when("syncValidation",{
                                                                         is: (syncValidation) => {return syncFormValidation},
                                                                          then: Yup.string().required(TRANSLATION('errors:required')).nullable(true),
                                                                          otherwise: Yup.string().nullable()
                                                          }),
                                                    checkValidation: Yup.boolean(),
                                                    contact_no: Yup.string().when("checkValidation",{
                                                                         is: (checkValidation) => {return showValidation},
                                                                          then: Yup.string().required(TRANSLATION('errors:required'))
                                                                          .matches(phoneRegex, TRANSLATION('errors:no_special_char'))
                                                                      }),

                                                    email: Yup.string().when("checkValidation",{
                                                                         is: (checkValidation) => {return showValidation},
                                                                          then: Yup.string().required(TRANSLATION('errors:required'))

                                                          }),
                                                    location_attributes: Yup.object().shape({
                                                        full_address: Yup.string().when("checkValidation",{
                                                                         is: (checkValidation) => {return locationValidationCheck},
                                                                          then: Yup.string().required(TRANSLATION('errors:required')),
                                                                          otherwise: Yup.string().nullable()

                                                          })
                                                    }),
                                                    offer_approvals_attributes: Yup.array().of(
                                                      Yup.object({
                                                        approver_emails: Yup.array(),
                                                        minimum_approval_required: Yup.string().when("approver_emails", {
                                                          is: (approver_emails) => {
                                                            return approver_emails.length > 0
                                                          },
                                                          then: Yup.string().required(TRANSLATION('errors:required')).nullable(),
                                                          otherwise: Yup.string().notRequired()
                                                        }),
                                                      })
                                                    )
                                                  })
                                                }

  const ADD_TO_OFFER_SCHEMA =   Yup.object(a)

return ADD_TO_OFFER_SCHEMA
}

